<template>
    <div>
        <section class="base-header-sec base-header-laen  laen">
            <div class="base-header__top-line laen"></div>
            <div class="container-fluid">
                <div class="   base-header__container ">
                    <div class="  d-flex justify-content-center align-items-center">
                        <h1 class="base-header__title text-center py-2">
                            Регистрација за ПРОМО период
                        </h1>
                    </div>
                </div>
            </div>
        </section>

        <div class="container-fluid base-container">
            <div class="base-box p-normal">
                <b-form @submit.stop.prevent="onSubmit" v-on:keyup.enter="submit">
                    <div class="row">
                        <div class="col-md-3"></div>
                        <div class="col-md-6">
                            <div class="form-group form-group-sm">
                                <label class="form-label">Име <span class="required">*</span></label>
                                <input type="text" v-model="$v.firstName.$model" class="form-control full-width"
                                    :class="{ 'is-invalid form-group--error': $v.firstName.$error }">
                            </div>
                            <div v-if="$v.firstName.$dirty">
                                <div class="form-error" v-if="!$v.firstName.required">Поље је обавезно</div>
                            </div>

                            <div class="form-group form-group-sm">
                                <label class="form-label">Презиме <span class="required">*</span></label>
                                <input type="text" v-model="$v.lastName.$model" class="form-control full-width"
                                    :class="{ 'is-invalid form-group--error': $v.lastName.$error }">
                            </div>
                            <div v-if="$v.lastName.$dirty">
                                <div class="form-error" v-if="!$v.lastName.required">Поље је обавезно</div>
                            </div>

                            <div class="form-group form-group-sm">
                                <label class="form-label">Емаил <span class="required">*</span></label>
                                <input type="text" v-model="$v.email.$model" class="form-control full-width"
                                    :class="{ 'is-invalid form-group--error': $v.email.$error }">
                            </div>
                            <div v-if="$v.email.$dirty">
                                <div class="form-error" v-if="!$v.email.required">Поље је обавезно</div>
                                <div class="form-error" v-if="!$v.email.email">Унесите валидну емаил адресу</div>
                            </div>

                            <div class="form-group form-group-sm">
                                <label class="form-label">Телефон <span class="required">*</span></label>
                                <div class="d-flex align-items-center">
                                    <span class="mr-1 text-sm-left">+381 </span>
                                    <input type="text" v-model="$v.phone.$model" class="form-control full-width"
                                        :class="{ 'is-invalid form-group--error': $v.phone.$error }">
                                </div>
                            </div>
                            <div v-if="$v.phone.$dirty">
                                <div class="form-error" v-if="!$v.phone.required">Поље је обавезно</div>
                            </div>

                            <div class="form-group form-group-sm">
                                <label class="form-label">Назив фирме</label>
                                <input type="text" v-model="companyName" class="form-control full-width">
                            </div>

                            <div class="form-group form-group-sm">
                                <label class="form-label">Корисничко име <span class="required">*</span></label>
                                <input type="text" v-model="username" class="form-control full-width"
                                    :class="{ 'is-invalid form-group--error': $v.username.$error }">
                            </div>
                            <div v-if="$v.username.$dirty">
                                <div class="form-error" v-if="!$v.username.required">Поље је обавезно</div>
                            </div>
                        </div>
                        <div class="col-md-3"></div>

                    </div>
                    <div class="spacer20"></div>
                    <!-- <div class="d-md-flex justify-content-end align-items-center"> -->
                    <div class="d-md-flex justify-content-end align-items-center">
                        <div class="form-group form-group-sm">
                            <button type="button" @click="submit" class="btn btn-base-submit text-uppercase mr-3">
                                Пошаљи
                            </button>
                        </div>
                    </div>

                    <b-toast id="sms-confirm-success" title="СМС" class="b-toaster-top-right" static no-auto-hide>
                        Успешно сте се регистровали. Информације о приступу су Вам послате на емаил.
                    </b-toast>
                </b-form>
            </div>
        </div>

        <b-modal id="confirmation-modal" ref="confirmation-modal" title="СМС потврда">
            <b-toast id="sms-resend-success" title="СМС" static no-auto-hide>
                СМС вам је успешно послат.
            </b-toast>

            <form ref="form" @submit.stop.prevent="handleSubmit">
                <p>Унесите кôд који смо Вам послали СМС-ом:</p>
                <div class="form-group form-group-sm">
                    <input class="form-control" type="text" v-model="smsCode" style="letter-spacing: 3px">
                </div>
            </form>
            <template v-slot:modal-footer>
                <b-button variant="default" @click="resendSMS">Поново пошаљи СМС</b-button>
                <b-button variant="info" @click="submitCode">Пошаљи</b-button>
            </template>
        </b-modal>

    </div>
</template>

<script>
import axios from 'axios';
import { required, email } from 'vuelidate/lib/validators'


export default {
    name: "PromoForm",
    data() {
        return {
            uuid: null,
            smsCode: null,

            companyName: null,
            email: null,
            firstName: null,
            lastName: null,
            phone: null,
            username: null,

            successMessage: null,

            // axios
            promoApiUrl: window.env.VUE_APP_API_KCPROXY_DEV + 'proxy/RequestForPromo',
            promoResendUrl: window.env.VUE_APP_API_KCPROXY_DEV + 'proxy/ResendSms',
            promoConfirmUrl:window.env.VUE_APP_API_KCPROXY_DEV + 'proxy/ConfirmPromoRequest',

            baseApiUrl: window.env.VUE_APP_API_KCPROXY_DEV,
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    validations: {
        firstName: { required },
        lastName: { required },
        phone: { required },
        username: { required },
        email: { required, email },
    },
    methods: {
        submit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                axios.post(this.promoApiUrl, this.getData())
                    .then(response => {
                        this.uuid = response.data;
                        this.$refs['confirmation-modal'].show();
                    }).catch(error => {
                        console.log(error.response);
                        if (error.response.data.errorMessage !== undefined) {
                            this.$bvToast.toast(error.response.data.errorMessage, {
                                title: 'Glasnik',
                                variant: 'warning',
                            })
                        }
                    })
            }
        },
        getData() {
            return {
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                phone: '+381' + this.phone,
                companyName: this.companyName,
                userName: this.username,
            }
        },
        submitCode() {
            axios.post(this.promoConfirmUrl, {
                uuid: this.uuid,
                smsCode: this.smsCode,
            }).then(response => {
                console.log(response);
                this.$refs['confirmation-modal'].hide();
                this.$router.push('/?promo=1');
            }).catch(error => {
                if (error.response.data.errorMessage !== undefined) {
                    this.$bvToast.toast(error.response.data.errorMessage, {
                        title: 'Glasnik',
                        variant: 'warning',
                    })
                }
            })
        },
        resendSMS() {
            axios.post(this.promoResendUrl + "?uuid=" + this.uuid)
                .then(response => {
                    console.log(response);
                    this.$bvToast.toast('СМС вам је успешно послат.');
                })
        },
    },
    mounted() {
        // this.$refs['confirmation-modal'].show();
    },
    beforeCreate: function () {
        document.body.className = 'color_standard';
    }
}
</script>


<style scoped></style>
